import styled from "styled-components";
import bottomBorder from "../../../images/hadding-suprt.jpg";
import { Label, FieldContainer } from "../../Styles";

export const Container = styled.div`
  .row {
    margin-bottom: 5px;
  }
  @media screen and (max-width: 767px) {
    .row {
      margin-bottom: 0;
    }
  }
`;

export const SectionTitle = styled.h3`
  width: 100%;
  float: left;
  text-align: left;
  background: url(${bottomBorder}) bottom left no-repeat;
  padding: 0 0 15px;
  margin: 50px 0 45px;
  color: #0071bc;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 700;
  div {
    font-size: 14px;
  }
`;

export const DescriptionLabel = styled.label`
  width: 100%;
`;

export const CategoryLabel = styled.label`
  width: 40%;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

export const CategoryFieldContainer = styled(FieldContainer)``;

export const EditorWrapper = styled.div`
  float: left;
  width: 100%;
  .cke {
    border-radius: 4px;
  }
`;

export const LimitedAccess = styled.div`
  margin: -10px 0 40px 16px;
  width: 100%;
`;
